import { createMemoryCache } from 'create-fetcher/lib/caches/memory';
import { v1 as uuidv1 } from 'uuid';
import { App } from '../../lib/common/app';
import { Platform } from '../../lib/common/platform';
import { dispatchEvent } from './event';
export const envSupport = {};
/**
 * Note: envSupport should be called before setConfig, invoke it during loading
 * @param support
 */
export function addEnvSupport(support) {
    Object.assign(envSupport, support);
}
export var EncryptMethodEnum;
(function (EncryptMethodEnum) {
    EncryptMethodEnum[EncryptMethodEnum["UNDEFINED"] = 0] = "UNDEFINED";
    EncryptMethodEnum[EncryptMethodEnum["BASE64"] = 1] = "BASE64";
    EncryptMethodEnum[EncryptMethodEnum["INNO_SECURE"] = 2] = "INNO_SECURE";
})(EncryptMethodEnum || (EncryptMethodEnum = {}));
export const config = {
    apiServer: '',
    platform: '',
    app: App.APP_UNDEFINED,
    appVersion: '',
    token: '',
    tk: '',
    sessionID: '',
    headers: {},
    log: false,
    cache: createMemoryCache(),
    crypter: null,
    storage: null,
    report: null,
    webSocket: false,
};
/**
 * convert platform name string to interface defined enum
 * @param platform platform name, default using config.platform
 */
function toPlatformEnum(platform) {
    switch (platform) {
        case 'android':
            return Platform.PLATFORM_ANDROID;
        case 'ios':
            return Platform.PLATFORM_IOS;
        case 'web':
            return Platform.PLATFORM_WEB;
        default:
            return Platform.PLATFORM_UNDEFINED;
    }
}
/**
 * get api Platform enum for using in api methods arguments
 * @returns Platform enum value
 */
export function getPlatformEnum() {
    var _a;
    return (_a = toPlatformEnum(config.platform)) !== null && _a !== void 0 ? _a : Platform.PLATFORM_UNDEFINED;
}
/**
 * get api App enum for using in api methods
 * @returns App enum value
 */
export function getAppEnum() {
    var _a;
    return (_a = config.app) !== null && _a !== void 0 ? _a : App.APP_UNDEFINED;
}
const contextParams = {};
/**
 * get current context params
 * @returns current context params
 */
export function getContextParams() {
    return contextParams;
}
/**
 * set context params
 * @param params
 */
export function setContextParams(params) {
    Object.assign(contextParams, params);
    dispatchEvent('contextParamsChanged', params);
}
const uuid = () => uuidv1({ rng: envSupport.rng });
export function setConfig(params) {
    // keep track of prev token
    const prevToken = config.token;
    Object.assign(config, params);
    // clear fetcher cache on logout
    if (!config.token && prevToken) {
        config.cache.clear();
    }
    // generate default sessionID if it's not set
    if (!config.sessionID) {
        config.sessionID = uuid();
    }
    dispatchEvent('configUpdated');
    setContextParams({
        tk: config.tk,
        platform: config.platform,
        app: config.app,
        app_version: config.appVersion,
        session_id: config.sessionID,
    });
}
